import styled from "styled-components";

export const FilterBarContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;

export const FilterBarLeftContent = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }

  & > *:first-child {
    flex: 1;
    min-width: 0;
    max-width: clamp(200px, 40vw, 400px);
  }

  & > *:not(:first-child) {
    flex-shrink: 0;
  }
`;

export const SearchFieldWrapper = styled.div`
  min-width: 0;
`;

export const FilterBarRightContent = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  width: 150px;
  height: 100%;
  padding-inline-start: 30px;
`;